// DrawerContext.ts
import React from 'react';

interface DrawerContextType {
  drawerHeight: number;
  setDrawerHeight: (height: number) => void;
}

const DrawerContext = React.createContext<DrawerContextType>({
  drawerHeight: 0,
  setDrawerHeight: () => {}
});

export default DrawerContext;

export const useDrawerContext = () => React.useContext(DrawerContext);